import { apiFetch } from '../App/api'

export function missions(actionObj) {
    let loading = 'MISSIONS_LOADING' 
    let success = 'MISSIONS_SUCCESS' 
    let errorMessage = 'Unable to load missions'

    var url = 'http://calvarychapelyelm.org/api/missions'

    let request = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    }
    
    return apiFetch(url, request, loading, success, errorMessage)
}